module.exports = __webpack_public_path__ + "media/images/icons/twitter_circle-b3d261ce1e8278a041760bba8a3616e0.svg";